// SEO Data: Cities, Districts, and Services for FarbWelt Service
// This file contains all location and service data for SEO landing pages

export const cities = {
  dormagen: {
    name: "Dormagen",
    slug: "dormagen",
    region: "Rhein-Kreis Neuss",
    plz: ["41539", "41540", "41541", "41542"],
    coordinates: { lat: 51.0967, lng: 6.8317 },
    description: "Dormagen ist eine Stadt im Rhein-Kreis Neuss in Nordrhein-Westfalen. Mit rund 65.000 Einwohnern ist sie ein wichtiger Wirtschaftsstandort zwischen Düsseldorf und Köln.",
    districts: [
      { name: "Dormagen-Mitte", slug: "mitte" },
      { name: "Horrem", slug: "horrem" },
      { name: "Hackenbroich", slug: "hackenbroich" },
      { name: "Nievenheim", slug: "nievenheim" },
      { name: "Zons", slug: "zons" },
      { name: "Rheinfeld", slug: "rheinfeld" },
      { name: "Delrath", slug: "delrath" },
      { name: "Gohr", slug: "gohr" },
      { name: "Straberg", slug: "straberg" },
      { name: "Delhoven", slug: "delhoven" },
      { name: "Stürzelberg", slug: "stuerzelberg" },
    ],
  },
  duesseldorf: {
    name: "Düsseldorf",
    slug: "duesseldorf",
    region: "Landeshauptstadt NRW",
    plz: ["40210", "40211", "40212", "40213", "40215", "40217", "40219", "40221", "40223", "40225", "40227", "40229", "40231", "40233", "40235", "40237", "40239", "40468", "40470", "40472", "40474", "40476", "40477", "40479", "40489", "40545", "40547", "40549", "40589", "40591", "40593", "40595", "40597", "40599", "40625", "40627", "40629"],
    coordinates: { lat: 51.2277, lng: 6.7735 },
    description: "Düsseldorf ist die Landeshauptstadt Nordrhein-Westfalens und ein bedeutendes Wirtschafts-, Kultur- und Modezentrum. Mit über 620.000 Einwohnern ist sie die siebtgrößte Stadt Deutschlands.",
    districts: [
      { name: "Stadtmitte", slug: "stadtmitte" },
      { name: "Altstadt", slug: "altstadt" },
      { name: "Bilk", slug: "bilk" },
      { name: "Unterbilk", slug: "unterbilk" },
      { name: "Oberbilk", slug: "oberbilk" },
      { name: "Friedrichstadt", slug: "friedrichstadt" },
      { name: "Derendorf", slug: "derendorf" },
      { name: "Pempelfort", slug: "pempelfort" },
      { name: "Golzheim", slug: "golzheim" },
      { name: "Flingern Nord", slug: "flingern-nord" },
      { name: "Flingern Süd", slug: "flingern-sued" },
      { name: "Eller", slug: "eller" },
      { name: "Garath", slug: "garath" },
      { name: "Benrath", slug: "benrath" },
      { name: "Kaiserswerth", slug: "kaiserswerth" },
      { name: "Rath", slug: "rath" },
      { name: "Heerdt", slug: "heerdt" },
      { name: "Oberkassel", slug: "oberkassel" },
      { name: "Lörick", slug: "loerick" },
      { name: "Holthausen", slug: "holthausen" },
      { name: "Reisholz", slug: "reisholz" },
      { name: "Wersten", slug: "wersten" },
      { name: "Himmelgeist", slug: "himmelgeist" },
      { name: "Angermund", slug: "angermund" },
      { name: "Gerresheim", slug: "gerresheim" },
      { name: "Grafenberg", slug: "grafenberg" },
      { name: "Mörsenbroich", slug: "moersenbroich" },
      { name: "Düsseltal", slug: "duesseltal" },
      { name: "Stockum", slug: "stockum" },
      { name: "Niederkassel", slug: "niederkassel" },
      { name: "Hassels", slug: "hassels" },
      { name: "Urdenbach", slug: "urdenbach" },
      { name: "Vennhausen", slug: "vennhausen" },
      { name: "Unterrath", slug: "unterrath" },
      { name: "Lichtenbroich", slug: "lichtenbroich" },
      { name: "Flehe", slug: "flehe" },
      { name: "Volmerswerth", slug: "volmerswerth" },
      { name: "Hamm", slug: "hamm" },
      { name: "Ludenberg", slug: "ludenberg" },
      { name: "Hubbelrath", slug: "hubbelrath" },
      { name: "Knittkuhl", slug: "knittkuhl" },
      { name: "Itter", slug: "itter" },
      { name: "Wittlaer", slug: "wittlaer" },
      { name: "Lohausen", slug: "lohausen" },
      { name: "Carlstadt", slug: "carlstadt" },
    ],
  },
  koeln: {
    name: "Köln",
    slug: "koeln",
    region: "Regierungsbezirk Köln",
    plz: ["50667", "50668", "50670", "50672", "50674", "50676", "50677", "50678", "50679", "50733", "50735", "50737", "50739", "50765", "50767", "50769", "50823", "50825", "50827", "50829", "50858", "50859", "50931", "50933", "50935", "50937", "50939", "50968", "50969", "50996", "50997", "50999", "51061", "51063", "51065", "51067", "51069", "51103", "51105", "51107", "51109", "51143", "51145", "51147", "51149"],
    coordinates: { lat: 50.9375, lng: 6.9603 },
    description: "Köln ist mit über 1 Million Einwohnern die größte Stadt Nordrhein-Westfalens und die viertgrößte Stadt Deutschlands. Die Domstadt am Rhein ist bekannt für ihre kulturelle Vielfalt.",
    districts: [
      { name: "Innenstadt", slug: "innenstadt" },
      { name: "Ehrenfeld", slug: "ehrenfeld" },
      { name: "Nippes", slug: "nippes" },
      { name: "Kalk", slug: "kalk" },
      { name: "Mülheim", slug: "muelheim" },
      { name: "Porz", slug: "porz" },
      { name: "Chorweiler", slug: "chorweiler" },
      { name: "Lindenthal", slug: "lindenthal" },
      { name: "Rodenkirchen", slug: "rodenkirchen" },
      { name: "Deutz", slug: "deutz" },
      { name: "Poll", slug: "poll" },
      { name: "Sülz", slug: "suelz" },
      { name: "Klettenberg", slug: "klettenberg" },
      { name: "Bayenthal", slug: "bayenthal" },
      { name: "Marienburg", slug: "marienburg" },
      { name: "Raderberg", slug: "raderberg" },
      { name: "Raderthal", slug: "raderthal" },
      { name: "Zollstock", slug: "zollstock" },
      { name: "Riehl", slug: "riehl" },
      { name: "Neuehrenfeld", slug: "neuehrenfeld" },
      { name: "Bickendorf", slug: "bickendorf" },
      { name: "Ossendorf", slug: "ossendorf" },
      { name: "Neustadt-Nord", slug: "neustadt-nord" },
      { name: "Neustadt-Süd", slug: "neustadt-sued" },
      { name: "Altstadt-Nord", slug: "altstadt-nord" },
      { name: "Altstadt-Süd", slug: "altstadt-sued" },
      { name: "Braunsfeld", slug: "braunsfeld" },
      { name: "Junkersdorf", slug: "junkersdorf" },
      { name: "Lövenich", slug: "loevenich" },
      { name: "Weiden", slug: "weiden" },
      { name: "Widdersdorf", slug: "widdersdorf" },
    ],
  },
  leverkusen: {
    name: "Leverkusen",
    slug: "leverkusen",
    region: "Kreisfreie Stadt",
    plz: ["51371", "51373", "51375", "51377", "51379", "51381"],
    coordinates: { lat: 51.0459, lng: 6.9844 },
    description: "Leverkusen ist eine kreisfreie Stadt in Nordrhein-Westfalen mit rund 165.000 Einwohnern. Die Stadt liegt am Rhein zwischen Köln und Düsseldorf.",
    districts: [
      { name: "Wiesdorf", slug: "wiesdorf" },
      { name: "Opladen", slug: "opladen" },
      { name: "Schlebusch", slug: "schlebusch" },
      { name: "Rheindorf", slug: "rheindorf" },
      { name: "Küppersteg", slug: "kueppersteg" },
      { name: "Hitdorf", slug: "hitdorf" },
      { name: "Quettingen", slug: "quettingen" },
      { name: "Bürrig", slug: "buerrig" },
      { name: "Manfort", slug: "manfort" },
      { name: "Steinbüchel", slug: "steinbuechel" },
      { name: "Lützenkirchen", slug: "luetzenkirchen" },
      { name: "Bergisch Neukirchen", slug: "bergisch-neukirchen" },
    ],
  },
  monheim: {
    name: "Monheim am Rhein",
    slug: "monheim",
    region: "Kreis Mettmann",
    plz: ["40789"],
    coordinates: { lat: 51.0917, lng: 6.8917 },
    description: "Monheim am Rhein ist eine Stadt im Kreis Mettmann in Nordrhein-Westfalen mit rund 43.000 Einwohnern. Die Stadt liegt direkt am Rhein zwischen Düsseldorf und Köln.",
    districts: [
      { name: "Monheim-Mitte", slug: "mitte" },
      { name: "Baumberg", slug: "baumberg" },
    ],
  },
};

export const services = {
  innenanstrich: {
    name: "Innenanstrich",
    slug: "innenanstrich",
    shortDescription: "Professionelle Malerarbeiten für Innenräume",
    description: "Ob Wohnzimmer, Schlafzimmer, Küche oder Büro – wir streichen Ihre Innenräume fachgerecht und sauber. Mit hochwertigen Farben und präziser Arbeit sorgen wir für ein perfektes Ergebnis.",
    keywords: ["Innenanstrich", "Wände streichen", "Decken streichen", "Wandfarbe", "Raumgestaltung"],
    benefits: [
      "Saubere und präzise Arbeit",
      "Hochwertige, langlebige Farben",
      "Individuelle Farbberatung",
      "Termintreue Ausführung",
    ],
  },
  fassadenarbeiten: {
    name: "Fassadenarbeiten",
    slug: "fassadenarbeiten",
    shortDescription: "Fassadenanstrich und Fassadensanierung",
    description: "Eine gepflegte Fassade ist die Visitenkarte Ihres Hauses. Wir bieten professionellen Fassadenanstrich, Fassadensanierung und Wärmedämmung für Ihr Gebäude.",
    keywords: ["Fassadenanstrich", "Fassadensanierung", "Außenanstrich", "Hausfassade", "Fassadenrenovierung"],
    benefits: [
      "Witterungsbeständige Farben",
      "Schutz vor Feuchtigkeit",
      "Energieeffizienz durch Dämmung",
      "Wertsteigerung der Immobilie",
    ],
  },
  tapezierarbeiten: {
    name: "Tapezierarbeiten",
    slug: "tapezierarbeiten",
    shortDescription: "Professionelles Tapezieren aller Art",
    description: "Von klassischen Raufasertapeten bis hin zu hochwertigen Vliestapeten und Mustertapeten – wir tapezieren Ihre Räume professionell und sauber.",
    keywords: ["Tapezieren", "Tapezierarbeiten", "Vliestapete", "Raufaser", "Mustertapete", "Tapetenwechsel"],
    benefits: [
      "Blasenfreies Ergebnis",
      "Saubere Kanten und Übergänge",
      "Große Tapeten-Auswahl",
      "Entfernung alter Tapeten",
    ],
  },
  lackierarbeiten: {
    name: "Lackierarbeiten",
    slug: "lackierarbeiten",
    shortDescription: "Lackierung von Türen, Fenstern und Möbeln",
    description: "Professionelle Lackierarbeiten für Türen, Fenster, Heizkörper und Möbel. Wir arbeiten mit hochwertigen Lacken für ein perfektes und langlebiges Finish.",
    keywords: ["Lackierarbeiten", "Türen lackieren", "Fenster lackieren", "Heizkörper lackieren", "Möbellackierung"],
    benefits: [
      "Glatte, gleichmäßige Oberflächen",
      "Hochwertige Lacke",
      "Schutz vor Abnutzung",
      "Aufarbeitung alter Elemente",
    ],
  },
  renovierung: {
    name: "Renovierung",
    slug: "renovierung",
    shortDescription: "Komplette Wohnungsrenovierung aus einer Hand",
    description: "Komplettrenovierung Ihrer Wohnung oder einzelner Räume. Von der Planung bis zur Endreinigung – wir übernehmen alle Malerarbeiten für Ihre Renovierung.",
    keywords: ["Renovierung", "Wohnungsrenovierung", "Zimmer renovieren", "Komplettrenovierung", "Sanierung"],
    benefits: [
      "Alles aus einer Hand",
      "Koordinierte Abläufe",
      "Festpreisangebote möglich",
      "Termingerechte Fertigstellung",
    ],
  },
  wohnungsuebergabe: {
    name: "Wohnungsübergabe",
    slug: "wohnungsuebergabe",
    shortDescription: "Streichen bei Ein- und Auszug",
    description: "Sie ziehen um? Wir streichen Ihre Wohnung für die Übergabe – schnell, sauber und zuverlässig. Auch kurzfristige Termine möglich.",
    keywords: ["Wohnungsübergabe", "Auszug streichen", "Einzug streichen", "Umzug Maler", "Übergabe Wohnung"],
    benefits: [
      "Schnelle Terminvergabe",
      "Express-Service möglich",
      "Übergabegerechtes Ergebnis",
      "Stressfreier Umzug",
    ],
  },
  spachtelarbeiten: {
    name: "Spachtelarbeiten",
    slug: "spachtelarbeiten",
    shortDescription: "Wände und Decken perfekt vorbereiten",
    description: "Perfekte Oberflächen beginnen mit professionellen Spachtelarbeiten. Wir beseitigen Risse, Löcher und Unebenheiten für ein makelloses Endergebnis.",
    keywords: ["Spachtelarbeiten", "Wände spachteln", "Risse ausbessern", "Untergrundvorbereitung", "Glätten"],
    benefits: [
      "Perfekt vorbereitete Untergründe",
      "Glatte Oberflächen",
      "Professionelle Materialien",
      "Grundlage für perfektes Streichen",
    ],
  },
  trockenbau: {
    name: "Trockenbau",
    slug: "trockenbau",
    shortDescription: "Trockenbauarbeiten und Gipskarton",
    description: "Vom Abhängen von Decken über Trockenbauwände bis hin zu Dachausbau – wir realisieren Ihre Trockenbau-Projekte fachgerecht.",
    keywords: ["Trockenbau", "Gipskarton", "Rigips", "Decke abhängen", "Trockenbauwand", "Dachausbau"],
    benefits: [
      "Saubere Verarbeitung",
      "Schnelle Umsetzung",
      "Individuelle Raumgestaltung",
      "Schall- und Wärmedämmung",
    ],
  },
};

// Helper function to generate SEO-optimized content
export const generatePageTitle = (service, city, district = null) => {
  if (district) {
    return `${service.name} in ${city.name}-${district.name} | FarbWelt Service`;
  }
  return `${service.name} in ${city.name} | Ihr Maler vom Fach`;
};

export const generateMetaDescription = (service, city, district = null) => {
  const location = district ? `${city.name}-${district.name}` : city.name;
  return `Professionelle ${service.name} in ${location}. ✓ Kostenlose Beratung ✓ Faire Preise ✓ Termingerecht. Jetzt Besichtigungstermin buchen bei FarbWelt Service!`;
};

// Get all URL combinations for sitemap
export const getAllSeoUrls = () => {
  const urls = [];
  
  // City main pages
  Object.values(cities).forEach(city => {
    urls.push(`/maler-${city.slug}`);
    
    // City + District pages
    city.districts.forEach(district => {
      urls.push(`/maler-${city.slug}-${district.slug}`);
    });
  });
  
  // Service pages
  Object.values(services).forEach(service => {
    urls.push(`/leistungen/${service.slug}`);
  });
  
  // Service + City combinations
  Object.values(services).forEach(service => {
    Object.values(cities).forEach(city => {
      urls.push(`/${service.slug}-${city.slug}`);
    });
  });
  
  return urls;
};

export default { cities, services, generatePageTitle, generateMetaDescription, getAllSeoUrls };
